import React from "react"
import { Stack } from "@chakra-ui/react"
import { DioboxEvent, SubscriptionType } from "sharedTypes"
import SettingsSection from "components/settings/SettingsSection"
import UpgradeAlert from "components/elements/UpgradeAlert"
import Zapier from "./Zapier"
import HowZapierWorks from "./HowZapierWorks"

type Props = {
  event: DioboxEvent
}

const Integrations = ({ event }: Props) => (
  <Stack spacing={12}>
    <SettingsSection
      title="Integrations"
      description="Connect Diobox with the apps and services you use to automate workflows, sync guest data, and keep information moving seamlessly across your tools."
    >
      {!event.zapierEnabled && (
        <UpgradeAlert
          text="This feature requires an Enterprise plan."
          defaultSelectedPlan={SubscriptionType.Enterprise}
        />
      )}
    </SettingsSection>
    <Zapier eventId={event.id} enabled={event.zapierEnabled} />
    <HowZapierWorks enabled={event.zapierEnabled} />
  </Stack>
)

export default Integrations
